import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import newReports from './sidebarItems/newReports';
import claudia from './sidebarItems/claudia';

export const getSidebarItems = (accountId, locale = 'pt_BR') => ({
  primaryMenu: primaryMenu(accountId, locale),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    settings(accountId),
    notifications(accountId),
    newReports(accountId),
    claudia(accountId),
  ],
});
